import { render, staticRenderFns } from "./SSNCard.vue?vue&type=template&id=6138b1ac&scoped=true&"
import script from "./SSNCard.vue?vue&type=script&lang=ts&"
export * from "./SSNCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6138b1ac",
  null
  
)

export default component.exports